// File type configuration for supporting documents

export const ALLOWED_FILE_TYPES = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Map of file_id from DB to display label
export const FILE_TYPE_MAP = {
  1: { label: "3 Months Bank Statement" },
  2: { label: "Application Form" },
  3: { label: "CIPC Certificate" },
  4: { label: "Copy of Account Payer ID" },
  5: { label: "Copy of Matric Certificate/NQF4" },
  6: { label: "Copy of Student ID/Passport" },
  7: { label: "Disability Doc" },
  8: { label: "Foreign Student: Study Permit" },
  9: { label: "Proof of Account Payers Address" },
  10: { label: "Proof of Highest Qualification" },
  11: { label: "Proof of Income" },
  12: { label: "Proof of Payment", helperText: { text: "To complete your re-registration, please ensure you pay the minimum deposit of ", boldText: "R7 000" } },
  13: { label: "Purchase Order" },
  14: { label: "Signed debit order authority form" },
  101: { label: "ITC Checks" },
  102: { label: "Bank Account Confirmation Letter" }
};

export const DEFAULT_DOWNLOAD_FILES = [
  {
    value: 1,
    label: "Debit Order Form",
    description: "Please download this form for your account payer to complete.",
    url: "https://myaie.ac/Library/reregistration/Debit Order Form_V130824_2.pdf",
  },
];

export const DefaultFiles = [
  {
    id: 1,
    file_id: 12,
    uploaded: 0,
    active: 1,
    file_path: 'https://crm.aie.ac/customer1234/file.pdf',
    required: 1,
  },
  {
    id: 2,
    file_id: 14,
    uploaded: 0,
    active: 1,
    file_path: 'https://crm.aie.ac/customer1234/file.pdf',
    required: 1,
    path:'',
  }
];

